<template>
  <b-btn @click="gotoTop()" :type="type" class="btn-menu-new   bg-transparent">
    <slot></slot>
  </b-btn>
</template>

<script>
export default {
  name: "Bt8",
  props: ["type"],
  methods: {
    gotoTop() {
      window.scroll(0, 0)
    }
  }
};
</script>

<style>

.btn-menu-new {
  color: var(--primary);
  border: none;
}

.btn-menu-new:hover {
  border: 1px solid var(--secondary);
  border-radius: 30px;
  color: var(--secondary);
  transition: all 0.3s ease 0s;
}

</style>